export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-start justify-between mb-12">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-brush-line text-3xl text-white"></i>
            </div>
            <span className="text-2xl font-bold" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>絵 仕事</span>
          </div>
          <p className="text-sm text-gray-400 max-w-md text-right leading-relaxed">
            あなたの想いを絵で表現する、<br />
            クリエイティブパートナー
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>サービス</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">ブランドイラストレーション</a></li>
              <li><a href="#services" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">書籍・出版イラスト</a></li>
              <li><a href="#services" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Webサイトイラスト</a></li>
              <li><a href="#services" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">キャラクターデザイン</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>会社情報</h4>
            <ul className="space-y-3">
              <li><a href="#concept" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">コンセプト</a></li>
              <li><a href="#portfolio" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">制作実績</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">会社概要</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">採用情報</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>サポート</h4>
            <ul className="space-y-3">
              <li><a href="#contact" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">お問い合わせ</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">よくある質問</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">料金について</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">制作の流れ</a></li>
            </ul>
          </div>

          <div className="text-right">
            <p className="text-2xl font-bold mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>© 2024 絵 仕事</p>
            <p className="text-sm text-gray-400 mb-6">All rights reserved</p>
            <div className="flex gap-4 justify-end">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-2xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-circle-line text-2xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-box-line text-2xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">
            〒150-0001 東京都渋谷区神宮前1-2-3 クリエイティブビル5F
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">プライバシーポリシー</a>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">利用規約</a>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">特定商取引法</a>
          </div>
        </div>
      </div>
    </footer>
  );
}